module.exports = __webpack_public_path__ + "static/img/ic_arrow_right_gray.c2c984f8.svg";